import FormContent from './FormContent';
import { SimpleFormStyled } from './styled';
import { CandidateEditStatusProps } from './types';

const CandidateEditStatus = (props: CandidateEditStatusProps) => {
  return (
    <SimpleFormStyled mode="onChange" reValidateMode="onChange" toolbar={false}>
      <FormContent {...props} />
    </SimpleFormStyled>
  );
};

export default CandidateEditStatus;
